export const FirebaseConfig = {
	"projectId": "jsrtaxi-3a029",
	"appId": "1:420174609222:web:52a61cc4c86e3352a2c347",
	"databaseURL": "https://jsrtaxi-3a029-default-rtdb.firebaseio.com",
	"storageBucket": "jsrtaxi-3a029.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyD9KgeJEMzmPFEkCpRlryzzH-SNvi3SXi0",
	"authDomain": "jsrtaxi-3a029.firebaseapp.com",
	"messagingSenderId": "420174609222",
	"measurementId": "G-FRK0J4ESSQ"
};